/**
 * 是否为手机 / 平板等典型移动端访问（含 iPad、iPadOS 桌面模式下的 Safari）。
 * 用于登录等仅适合桌面端操作的入口拦截。
 */
export function isMobileDevice() {
  const ua = navigator.userAgent || "";
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Silk\b/i.test(ua)) {
    return true;
  }
  if (/\biPad\b/i.test(ua)) return true;
  // iPadOS 13+ 可能将 UA 报成 Macintosh，但带多点触控
  if (typeof navigator.maxTouchPoints === "number" && navigator.maxTouchPoints > 1 && /\bMacintosh\b/i.test(ua)) {
    return true;
  }
  return false;
}
